import { render, staticRenderFns } from "./CritterTable.vue?vue&type=template&id=00016511&"
import script from "./CritterTable.vue?vue&type=script&lang=js&"
export * from "./CritterTable.vue?vue&type=script&lang=js&"
import style0 from "./CritterTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports